import React, { FC } from 'react';
import { LinkStatisticsReport, LinkStatisticsList } from '../../LinkStatisticsModel';
import { DataTable, ColumnConfig } from '../../../DataTable';

interface Props {
  translation: any;
  columns: ColumnConfig<LinkStatisticsList>[];
  selectedColumns: string[];
  reportData?: LinkStatisticsReport;
  onSelectColumns(columns: string[]): void;
}

export const ReportTable: FC<Props> = ({ columns, reportData, translation, selectedColumns, onSelectColumns }) => {
  const rows = reportData?.linkStatisticsList || [];

  return <DataTable columns={columns} data={rows} translation={translation} columnSelect selectedColumns={selectedColumns} onSelectColumns={onSelectColumns} emptyMessage={translation.text_6448} />;
};
